var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overflow-visible"},[_c('v-img',{attrs:{"src":require("../assets/banner.jpg"),"height":"300"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }